import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import useTranslation from '@/hooks/useTranslation'

async function offStations(payload: any): Promise<any> {
  const dataResponse: any = await controllerDataConfigApi.getStationOff(payload)
  // axiosClient returns full AxiosResponse — actual data is in response.data
  const body = dataResponse?.data ?? dataResponse
  // API returns 200 with errorCode in body for business errors
  if (body?.errorCode) {
    throw new Error(body.errorMessage || 'Station off failed')
  }
  return body
}

interface UseSearchStationOffOptions {
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
}

function useSearchStationOff(options?: UseSearchStationOffOptions) {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation((payload: any) => offStations(payload), {
    onSuccess: (data: any) => {
      queryClient.invalidateQueries([queryKeys.stations])
      NotifyService.success(`${t('programs.viewBy.station')} ${t('OffSuccess')}`)
      // Call custom onSuccess if provided
      options?.onSuccess?.(data)
    },
    onError: (error: any) => {
      NotifyService.error(error)
      // Call custom onError if provided
      options?.onError?.(error)
    },
  })
}

export default useSearchStationOff
